import { render } from "./HelloTecnicoPage.vue?vue&type=template&id=5918f89d&scoped=true"
import script from "./HelloTecnicoPage.vue?vue&type=script&lang=js"
export * from "./HelloTecnicoPage.vue?vue&type=script&lang=js"

import "./HelloTecnicoPage.vue?vue&type=style&index=0&id=5918f89d&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5918f89d"]])

export default __exports__